import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/**
 * MomentiCta — sezione "Momenti" in fondo alla Dashboard: 3 card di CTA
 * (Setup, Mese, Settimana) + link "Stampa planner".
 *
 * Stateless: nessuna prop.
 */
export default function MomentiCta() {
  return (
    <section className="border-t border-line pt-12">
      <div className="mono-label mb-8">Momenti</div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-line border border-line">
        <CtaCard
          testid="cta-setup"
          to="/setup"
          numero="01"
          titolo="Setup anno / quarter"
          desc="Definisci tema, numeri importanti, obiettivi e KR. Con il coach."
        />
        <CtaCard
          testid="cta-quarterly"
          to="/trimestre"
          numero="02"
          titolo="Pianificazione trimestrale"
          desc="Chiudi il quarter, apri il prossimo. Target e priorità 2-3."
        />
        <CtaCard
          testid="cta-monthly"
          to="/mese"
          numero="03"
          titolo="Pianificazione mensile"
          desc="Reali del mese chiuso, azioni settimanali, capacità."
        />
        <CtaCard
          testid="cta-weekly"
          to="/settimana"
          numero="04"
          titolo="Review settimanale"
          desc="Valori reali, confidence, retrospettiva, MIT."
        />
      </div>
      <div className="mt-6">
        <Link
          to="/stampa"
          data-testid="cta-print"
          className="inline-flex items-baseline gap-3 font-mono text-xs uppercase tracking-[0.2em] text-soft hover:text-accent transition-colors"
        >
          <span>05</span> Stampa planner (PDF) →
        </Link>
      </div>
    </section>
  );
}

function CtaCard({ testid, to, numero, titolo, desc }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className="group bg-canvas hover:bg-ink hover:text-canvas transition-colors duration-300 p-8 md:p-10 flex flex-col justify-between min-h-[180px] cursor-pointer"
    >
      <div className="flex items-baseline justify-between">
        <span className="font-mono text-xs text-mute group-hover:text-mute">{numero}</span>
        <ArrowRight
          size={18}
          strokeWidth={1.5}
          className="opacity-40 group-hover:opacity-100 group-hover:translate-x-1 transition-all"
        />
      </div>
      <div>
        <h3 className="font-display text-xl md:text-2xl tracking-tight mb-2 leading-tight">{titolo}</h3>
        <p className="font-body text-sm leading-relaxed text-soft group-hover:text-mute">
          {desc}
        </p>
      </div>
    </Link>
  );
}
